"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../utils/classFunctions");
require("./index.scss");
const className = 'tooltip';
const Tooltip = (props) => {
    const { text, modificators, children } = props;
    const tooltipBlock = typeof text === 'string' ? (react_1.default.createElement("div", { className: `${className}__text-inner`, dangerouslySetInnerHTML: { __html: text.replace(/(?:\r\n|\r|\n)/g, '<br>') } })) : (react_1.default.createElement("div", { className: `${className}__text-inner` }, text));
    if (!text)
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    return (react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(className, modificators) },
        react_1.default.createElement("div", { className: `${className}__container` },
            react_1.default.createElement("div", { className: `${className}__text` },
                tooltipBlock,
                react_1.default.createElement("span", { className: `${className}__arrow` })),
            react_1.default.createElement("span", { className: `${className}__button` }, children))));
};
exports.Tooltip = Tooltip;
//# sourceMappingURL=index.js.map